import React from 'react';
import * as Styles from './Styles';
import { Panel } from './panel';

type Props = {};

export const BaseView = (_props: Props) => {
	return (
		<Styles.Wrapper>
			<Styles.Container>
				<Styles.VideoBg autoPlay muted loop>
					<source src="/video/background.mp4" type="video/mp4" />
				</Styles.VideoBg>
				<Panel />
				<Styles.StyledSvgDecorLogin />
			</Styles.Container>
		</Styles.Wrapper>
	);
};
